import { render, staticRenderFns } from "./settingsTotal.vue?vue&type=template&id=23267c48&"
import script from "./settingsTotal.vue?vue&type=script&lang=js&"
export * from "./settingsTotal.vue?vue&type=script&lang=js&"
import style0 from "./settingsTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports